import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

import { Dialog, FormField } from "@/ds";
import {
  ANEXO_DIALOG_CANCELAR_LABEL,
  ANEXO_DIALOG_SALVAR_LABEL,
  ANEXO_ESCOLHER_LABEL,
  ANEXO_REMOVER_ESCOLHIDO_LABEL,
} from "./anexo-dialog.constants";
import styles from "./anexo-dialog.module.scss";
import type { AnexoDialogViewModel } from "./types-anexo-dialog";

/** Identificação do documento e área de arquivo (escolher ou arrastar e soltar), com Cancelar e Salvar. */
export function AnexoDialogView({
  title,
  identificacaoLabel,
  dica,
  dropTitulo,
  accept,
  testIds,
  inputRef,
  identificacao,
  arquivoNome,
  arquivoTamanho,
  arrastando,
  enviando,
  erroIdentificacao,
  erroArquivo,
  alterarIdentificacao,
  escolherArquivo,
  aoEscolherArquivo,
  aoArrastar,
  aoSairDoArraste,
  aoSoltar,
  descartarArquivo,
  salvar,
  cancelar,
}: AnexoDialogViewModel) {
  return (
    <Dialog
      visible
      onHide={cancelar}
      size="md"
      className="p-dialog-anexo"
      locked={enviando}
      header={title}
      focusOnShow={false}
      footer={
        <div className={styles.rodape}>
          <Button
            type="button"
            label={ANEXO_DIALOG_CANCELAR_LABEL}
            severity="secondary"
            disabled={enviando}
            onClick={cancelar}
            data-testid={testIds.cancelar}
          />
          <Button
            type="button"
            label={ANEXO_DIALOG_SALVAR_LABEL}
            loading={enviando}
            onClick={salvar}
            data-testid={testIds.confirmar}
          />
        </div>
      }
      data-testid={testIds.dialog}
    >
      <div className={styles.corpo}>
        <FormField.Root error={erroIdentificacao} testId={testIds.identificacao}>
          <FormField.Label>{identificacaoLabel}</FormField.Label>
          <FormField.Control>
            <InputText
              className={styles.controle}
              value={identificacao}
              onChange={(event) => alterarIdentificacao(event.target.value)}
              disabled={enviando}
              data-testid={testIds.identificacaoInput}
            />
          </FormField.Control>
          <FormField.Error />
        </FormField.Root>

        {arquivoNome === null ? (
          <div className={styles.arquivo}>
            <div
              className={styles.drop}
              data-arrastando={arrastando || undefined}
              data-invalido={erroArquivo ? "true" : undefined}
              onDragEnter={aoArrastar}
              onDragOver={aoArrastar}
              onDragLeave={aoSairDoArraste}
              onDrop={aoSoltar}
              data-testid={testIds.drop}
            >
              <i className={`pi pi-cloud-upload ${styles.dropIcone}`} aria-hidden="true" />
              <p className={styles.dropTitulo}>{dropTitulo}</p>
              <p className={styles.dropDica}>{dica}</p>
              <Button
                type="button"
                label={ANEXO_ESCOLHER_LABEL}
                severity="secondary"
                outlined
                size="small"
                onClick={escolherArquivo}
                data-testid={testIds.escolher}
              />
            </div>
            {erroArquivo ? (
              <p className={styles.erroArquivo} role="alert" data-testid={testIds.arquivoErro}>
                <i className="pi pi-times-circle" aria-hidden="true" />
                {erroArquivo}
              </p>
            ) : null}
          </div>
        ) : (
          <div className={styles.escolhido} data-testid={testIds.escolhido}>
            <div className={styles.escolhidoTexto}>
              <span className={styles.escolhidoNome}>{arquivoNome}</span>
              <span className={styles.escolhidoTamanho}>{arquivoTamanho}</span>
            </div>
            <Button
              type="button"
              icon="pi pi-trash"
              text
              severity="secondary"
              aria-label={ANEXO_REMOVER_ESCOLHIDO_LABEL}
              disabled={enviando}
              onClick={descartarArquivo}
              data-testid={testIds.descartar}
            />
          </div>
        )}

        <input
          ref={inputRef}
          type="file"
          accept={accept}
          className={styles.inputOculto}
          onChange={aoEscolherArquivo}
          tabIndex={-1}
          aria-hidden="true"
          data-testid={testIds.input}
        />
      </div>
    </Dialog>
  );
}
